













import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { generalDialogMixin } from '@/mixins'

export default mixins(generalDialogMixin).extend({
  props: {
    show: {
      type: Boolean,
    }
  },
  methods: {
  },
  mounted () {
    if (this.show === undefined) {
      console.error('[To Developer] :show= is required')
    }
  }
})
